module.exports = __webpack_public_path__ + "img/cst4.f80673f5.png";